import { css } from '@emotion/react';
import dayjs from 'dayjs';
import { WeaveLogo } from '@frontend/assets';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text, TextLink } from '@frontend/design-system';
import { useDentalInsuranceReportContext } from '../../context/DentalInsuranceReportDetailsContext.provider';

const linkToWeave = 'https://www.getweave.com/company/';

export const PrintableFooter = () => {
  const { t } = useTranslation('insuranceEligibilityReport');
  const {
    insuranceEligibilityReportData: { lastVerifiedAt },
  } = useDentalInsuranceReportContext();
  const currentDate: string = dayjs(lastVerifiedAt || new Date()).format('DD MMMM YYYY, hh:mm A');

  return (
    <footer css={footerStyle}>
      <div css={footerContainerStyle}>
        <WeaveLogo />
        <Text textAlign='center'>
          {t('The data in this document was retrieved on: {{date}}', {
            date: currentDate,
          })}
        </Text>
        <div>
          <Text textAlign='center'>
            {t('Rendered by ')}
            <TextLink href={linkToWeave}>{t('Weave')}</TextLink>
          </Text>
        </div>
      </div>
    </footer>
  );
};

const footerContainerStyle = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: theme.spacing(2, 3),
});

const footerStyle = css({
  backgroundColor: theme.colors.neutral10,
  padding: theme.spacing(2, 1),
  width: 'auto',
  marginTop: theme.spacing(1),
  bottom: 0,
  left: 0,
});
